import axios from "@/axios";
import { FORM_EDITOR_VARIANTS } from "../utils/constants";
import {
  getChangeCheckFieldEndpoints,
  getChangePackageFieldEndpoints,
} from "./endpoints";

const ENDPOINTS_MAP = {
  [FORM_EDITOR_VARIANTS.CHECK]: getChangeCheckFieldEndpoints,
  [FORM_EDITOR_VARIANTS.FORM]: getChangeCheckFieldEndpoints,
  [FORM_EDITOR_VARIANTS.PACKAGE]: getChangePackageFieldEndpoints,
};

export const changeBatchProcessing = async (config = {}) => {
  const {
    field,
    value = false,
    formEditor = FORM_EDITOR_VARIANTS.CHECK,
  } = config;

  if (!field || !ENDPOINTS_MAP[formEditor]) return;

  const endpoints = ENDPOINTS_MAP[formEditor](field.id);

  try {
    const response = await axios.patch(endpoints.batch_processing, {
      state: value,
    });
    return response?.data;
  } catch (error) {
    console.error("Error changing field property:", error);
    throw error;
  }
};
